import { render, staticRenderFns } from "./the-modal-wrapper.vue?vue&type=template&id=1ee2007b"
import script from "./the-modal-wrapper.vue?vue&type=script&lang=js"
export * from "./the-modal-wrapper.vue?vue&type=script&lang=js"
import style0 from "./the-modal-wrapper.vue?vue&type=style&index=0&id=1ee2007b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports